/** Nakshatra spans inside each rashi (sidereal 30° signs). */
import { NAKSHATRA_WHEEL_NAMES, NAKSHATRA_WHEEL_NAMES_HI } from './jyotishaNakshatraWheel';

const NAK_DEG = 13 + 20 / 60; // 13°20'

function formatDeg(d) {
  const deg = Math.floor(d);
  const min = Math.round((d - deg) * 60);
  if (min === 0) return `${deg}°`;
  return `${deg}°${String(min).padStart(2, '0')}'`;
}

/**
 * @param {number} signNum 1–12
 * @returns {{ nameEn: string; nameHi: string; rangeEn: string; rangeHi: string; partial?: boolean }[]}
 */
export function nakshatrasInSign(signNum) {
  const signStart = (signNum - 1) * 30;
  const signEnd = signNum * 30;
  const rows = [];

  for (let i = 0; i < 27; i++) {
    const nakStart = i * NAK_DEG;
    const nakEnd = (i + 1) * NAK_DEG;
    if (nakEnd <= signStart || nakStart >= signEnd) continue;

    const clipStart = Math.max(nakStart, signStart) - signStart;
    const clipEnd = Math.min(nakEnd, signEnd) - signStart;
    const partial = nakStart < signStart || nakEnd > signEnd;

    rows.push({
      nameEn: NAKSHATRA_WHEEL_NAMES[i],
      nameHi: NAKSHATRA_WHEEL_NAMES_HI[i],
      rangeEn: `${formatDeg(clipStart)} – ${formatDeg(clipEnd)}`,
      rangeHi: `${formatDeg(clipStart)} – ${formatDeg(clipEnd)}`,
      partial,
    });
  }

  return rows;
}
